import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { StructuredListing } from '@hz-design-system/web-ui';
import { formatImageUrl, ImageSize } from '@ecg-marktplaats/media-util-js-lib';

import formatPrice from '../../../../utils/formatPrice';
import { trackGAEvent } from '../../../../utils/gaTracking';

import { TFeedItem } from 'types/TFeeds';

type TFeedItemProps = {
  item: TFeedItem;
};

const FeedItem = ({ item }: TFeedItemProps) => {
  const { t } = useI18nContext();

  const handleClick = () => {
    trackGAEvent('Click', 'CarsRecommender');
  };

  return (
    <StructuredListing
      title={item.title}
      price={formatPrice(item.price, false, t)}
      imageSrc={formatImageUrl(item.picture?.url, ImageSize.Large, item.picture?.sizes)}
      imageLoading="lazy"
      decoding="async"
      isMaskedLink={item.thinContent}
      data-testid="structured-listing"
      linkProps={{ href: item.url, onClick: () => handleClick() }}
    />
  );
};

export default React.memo(FeedItem);
